import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const BlacklineSchema = z.object({
	originalPayload: z.string(),
	fileData: z.string(),
	id: z.number(),
	importDate: z.date().nullable(),
	recordCount: z.number().default(0)
});

export type BlacklineSchema = z.infer<typeof BlacklineSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	searchTerm: string = '',
): Promise<{ data: BlacklineSchema[]; total: number }> => {
	try {
		let queryString = '';
		const searchParams = new URLSearchParams();

		if (pagination) {
			searchParams.append('pageSize', pagination.pageSize.toString());
			searchParams.append('pageIndex', pagination.pageIndex.toString());
		}

		if (sorting.length > 0) {
			searchParams.append('sortBy', sorting[0].id);
			searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
		}

		if (searchTerm) {
			searchParams.append('searchTerm', searchTerm);
		}

		queryString = `?${searchParams.toString()}`;
		const response = await fetch(
			`/Blackline${queryString}`,
		);
		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};